import React, { useEffect, useState } from "react";
import logo from "../../assets/General/jpeg-optimizer_fluteAllianceLogo.png";
import faBars from "../../assets/General/faBarsBlack.svg";
import faTimes from "../../assets/General/faTimesBlack.svg";
import "./header.css";
import { useNavigate } from 'react-router-dom';

const links = [
  {
    name: "Home",
    path: "home",
  },
  {
    name: "About Us",
    path: "about-us",
  },
  {
    name: "Registrations",
    path: "registrations",
  },
  {
    name: "Contact Us",
    path: "contact",
  },
  {
    name: "Photo Gallery",
    path: "gallery",
  },
  {
    name: "Private Instruction",
    path: "private-instruction",
  },
];

const HeaderOrig = () => {
  const navigate = useNavigate();
  const [scrollHeader, setScrollHeader] = useState(false);
  const [showMenu, setShowMenu] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);

  const changeHeader = () => {
    if (window.scrollY >= 80) {
      setScrollHeader(true);
    } else {
      setScrollHeader(false);
    }
  };

  const closeMenu = () => {
    setShowMenu(false);
    setShowOverlay(false);
  };

  useEffect(() => {
    const closeOverlayOnResize = () => {
      if (window.innerWidth >= 1090 && showOverlay) {
        setShowOverlay(false);
      }
    };

    window.addEventListener("scroll", changeHeader);
    window.addEventListener("resize", closeOverlayOnResize);

    return () => {
      window.removeEventListener("scroll", changeHeader);
      window.removeEventListener("resize", closeOverlayOnResize);
    };
  }, [showMenu, showOverlay]);

  return (
    <header className={`${scrollHeader ? "scroll-header" : ""} header`}>
      <nav className="nav nav__container" style={{ backgroundColor: "white", paddingTop: "2vh", paddingBottom: "2vh", marginTop: "-3vh" }}>
        <div onClick={() => navigate("/")} className="nav__logo">
            <img src={logo} alt="logo" className="nav__logo-img" />
        </div>

        <div
          className="nav__toggle"
          onClick={() => {
            setShowMenu(!showMenu);
            setShowOverlay(!showOverlay);
          }}
        >
          <a
            href="https://www.restaurantji.com/or/tigard/jojos-java-/"
            target="_blank"
            rel="noopener noreferrer"
            className="custom-link"
          >
          </a>
          <img src={faBars} alt="dropdown" className="bars" />
        </div>
      </nav>

      {showOverlay && (
        <div className={`overlay ${showOverlay ? "active" : ""}`}>
          <button
            className="overlay__close-button"
            onClick={() => setShowOverlay(false)}
          >
            <img src={faTimes} style={{ width: "6vw" }} alt="close" />
          </button>
          <ul className="overlay__menu-list">
            {links.map(({ name, path }, index) => (
              <li className="overlay__menu-item nav__item" key={index}>
                <div
                  className="nav__link"
                  onClick={() => {
                    navigate(`/${path}`);
                    closeMenu();
                  }}
                >
                  {name}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default HeaderOrig;

